<template>
  <div class="home">
    <div class="py-3">
      <div>
        <v-btn @click="loguj" color="success">Zaloguj</v-btn>
      </div>
      <div>
        <v-btn @click="wyloguj" color="error">Wyloguj</v-btn>
      </div>
    </div>
    <div class="py-3">
      <div>
        <v-btn @click="admin" color="success">Daj admin</v-btn>
      </div>
      <div>
        <v-btn @click="nieadmin" color="error">Zabierz admin</v-btn>
      </div>
    </div>
    <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="LetFitBe namber łan"/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    HelloWorld
  },
  methods: {
    loguj: function () {
      sessionStorage.setItem('token', 'true')
      location.reload()
    },
    wyloguj: function () {
      sessionStorage.removeItem('token', 'false')
      sessionStorage.removeItem('admin', 'false')
      location.reload()
    },
    admin: function () {
      sessionStorage.setItem('admin', 'true')
      location.reload()
    },
    nieadmin: function () {
      sessionStorage.removeItem('admin', 'false')
      location.reload()
    }
  }
}
</script>
